//import liraries
import React, { Component,useEffect,useState,useRef } from "react";
import { View, Text, TouchableOpacity, Image, Dimensions, TextInput,} from "react-native";
import CustomButton from "../../common/CustomButton";
import QuickLinks from "../../SubComponents/Profile/QuickLinks";
import {getPoolAccountdetail,getTagToPoolTransfer,getTagToTagTransferReq,getTagToTagTransferProc} from "../../api/apiManager"
import ModalAlert from "../../common/ModalAlert";
import CustomInput from "../../common/CustomInput";
import Countdown from "react-countdown";
import { get } from "lodash";
import { useLocation } from "react-router-dom";
import RootNavigation from "../../utilities/RootNavigation";
import useStyles from "./PoolToTagTransferSummary_Styles";

const rechargePattern = /^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/;
// create a component
const PoolToTagTransferSummary = (props) => {
  const styles = useStyles();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [otp, setOtp] = useState();
  const counterRef = useRef(null);
  const [transferData, setTranferData] = useState({});
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });
  const [selectedAmount, setSelectedAmount] = useState("");
  const {state} = useLocation()

  const onCloseModal = () => {
    setAlertModalVisible(false);
    RootNavigation.navigate("Transfer")
  };

  useEffect(() => {
    getPoolAccountDtls()
  },[])

  const getPoolAccountDtls = () => {
    setLoading(true);
    getPoolAccountdetail()
      .then((res) => {
        setLoading(false);
          setData(res || {});
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const onClickSubmit = () => {
    let finalAmount = 0;
      if (selectedAmount != "") {
        finalAmount = selectedAmount;
      }
    let params = {
      amount: finalAmount,
      fromVrn: state?.vrn?.vrn,
      tagId:state?.vrn?.fastagId,
    };
    getTagToPoolTransfer(params)
      .then((res) => {
        if (res.statusCode == 200) {
          setAlertModal({
            title: "Successful",
            status: "success",
            message: res?.message || "",
            navigateScreen: "PoolAccountScreen",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        } else {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res?.message || "",
            navigateScreen: "PoolAccountScreen",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        }
      })
      .catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: err?.message || "",
          navigateScreen: "PoolAccountScreen",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
      });
  };

  // tag to tag api
  const onsubmit = () => {
    let params = {
      amount: selectedAmount,
      targetVrn: state?.target?.vrn,
      targetTagId:state?.target?.fastagId,
      sourceVrn: state?.vrn?.vrn,
      sourceTagId: state?.vrn?.fastagId,
    };
    getTagToTagTransferReq(params)
      .then((res) => {
        if (res.statusCode == 200) {
          setTranferData(res || {})
          setOtpModalVisible(true)
        } else {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res?.message || "",
            navigateScreen: "PoolAccountScreen",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        }
      })
      .catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: err?.message || "",
          navigateScreen: "PoolAccountScreen",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
      });
  };

  const resendOTP = () => {
     counterRef.current.start();
     let params = {
       amount: selectedAmount,
       targetVrn: state?.target?.vrn,
       targetTagId:state?.target?.fastagId,
       sourceVrn: state?.vrn?.vrn,
       sourceTagId: state?.vrn?.fastagId,
     };
     getTagToTagTransferReq(params)
       .then((res) => {
         if (res.statusCode == 200) {
           setTranferData(res || {})
           setOtpModalVisible(true)
         } else {
           setAlertModal({
             title: "Error",
             status: "error",
             message: res?.message || "",
             navigateScreen: "PoolAccountScreen",
             actionButton: "OK",
           });
           setAlertModalVisible(true);
         }
       })
       .catch((err) => {
         setAlertModal({
           title: "Error",
           status: "error",
           message: err?.message || "",
           navigateScreen: "PoolAccountScreen",
           actionButton: "OK",
         });
         setAlertModalVisible(true);
       });
   };

  const validateOtp = () => {
    setLoading(true)
    let params ={
      txnId:transferData?.response?.txnId,
      bankTxnId:transferData?.response?.bankTxnId,
      otp:otp
    }
    getTagToTagTransferProc(params)
      .then((res) => {
        if (res.statusCode == 200) {
          setAlertModal({
            title: "Successful",
            status: "success",
            message: res?.message || "",
            actionButton: "OK",
          });
          setOtpModalVisible(false)
          setAlertModalVisible(true);
        } else {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res?.message || "",
            navigateScreen: "PoolAccountScreen",
            actionButton: "OK",
          });
          setOtpModalVisible(false)
          setAlertModalVisible(true);
        }
      })
      .catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: err?.message || "",
          navigateScreen: "PoolAccountScreen",
          actionButton: "OK",
        });
        setOtpModalVisible(false)
        setAlertModalVisible(true);
      });
  }

  const [timerState, setTimeState] = useState({
    times: [
      Date.now() + 5000,
      Date.now() + 12000,
      Date.now() + 17000,
      Date.now() + 22000,
    ],
    currentTimeIndex: 0,
    currentTime: Date.now() + 60000,
  });
  const timerRenderer = ({ hours, minutes, seconds, completed, api }) => {
    if (completed || isNaN(minutes)) {
      return (
        <>
          <Text>{"00:00"}</Text>
          <TouchableOpacity
            onPress={() => {
              setTimeState({
                times: [
                  Date.now() + 5000,
                  Date.now() + 12000,
                  Date.now() + 17000,
                  Date.now() + 22000,
                ],
                currentTimeIndex: 0,
                currentTime: Date.now() + 60000,
              });
              setTimeout(() => {
                api.start();
              }, 500);

              resendOTP();
            }}
          >
            <Text style={styles.resendTextStyle}>{"Resend"}</Text>
          </TouchableOpacity>
        </>
      );
    }
    return (
      <>
        <Text>
          {minutes}:{seconds}
        </Text>
        <View>
          <Text style={[styles.resendTextStyle, { color: "gray" }]}> {"Resend"} </Text>
        </View>
      </>
    );
  };

  const completeTime = () => {
    if (
      timerState.times.length - 1 <=
      timerState.times.indexOf(timerState.currentTime)
    )
      return;
    // move to next time
    timerState.currentTimeIndex++;
    timerState.currentTime = new Date(
      timerState.times[timerState.currentTimeIndex + 1]
    );
  };

  return (
    <View style={styles.mainContainer}>
      <View style={styles.iconContainer}>
        <TouchableOpacity
          onPress={() => {
            RootNavigation.navigate("Transfer/PoolSelection",{value:state?.value})
          }}
        >
          <Image
            source={require("../../assets/images/back.png")}
            style={styles.backIcon}
          />
        </TouchableOpacity>
        <Text style={styles.textStyle}>{ state?.value == "Tag To Pool" ? "Tag to Pool Transfer" : "Tag to Tag Transfer"}</Text>
      </View>
      <View style={styles.bodyStyle}>
        <View style={styles.bodyViewStyle}>
          <View style={styles.viewStyle}>
            <Text style={styles.selectedTextStyle}>{"Selected Tag"}</Text>
            <Text style={styles.debitTextStyle}>{"Debit From"}</Text>
          </View>

          <View style={styles.cardViewStyle}>
            <Image source={require("../../assets/images/Bitmap.png")} style={styles.bitMap} />
            <View style={styles.viewStyle1}>
              <Text style={styles.vrnTextStyle}> {state?.vrn?.vrn} </Text>
              <Text style={styles.vehicleModalTextStyle}> {state?.vehicleModel}</Text>
            </View>
            <Text style={styles.transferAmountTextStyle}>
            {"\u20B9  "} {state?.vrn?.fastagBalance?.toString().includes(".") ? state?.vrn?.fastagBalance.toFixed(2) : state?.vrn?.fastagBalance + ".00"  }
            </Text>
            <View style={{marginLeft:20,width:20,height:20,borderRadius:10,backgroundColor:"green"}}>
                <View />
            </View>
          </View>
          <View style={styles.viewStyle}>
            <Text style={styles.selectedTextStyle}>{state?.value == "Tag To Pool" ? "Pool Account" : "Selected Tag" }</Text>
            <Text style={styles.debitTextStyle}>{"Credit To"}</Text>
          </View>
          <View style={styles.cardViewStyle}>
            <Image
              source={require("../../assets/images/Bitmap.png")}
              style={styles.bitMap}
            />
            <View style={styles.viewStyle1}>
              <Text style={styles.vrnTextStyle} >
                {state?.value == "Tag To Pool" ? data?.accountNo :state?.target?.vrn}
              </Text>
              <Text style={styles.vehicleModalTextStyle}>
                {state?.value == "Tag To Pool" ? "Pool Account No." : state?.target?.vehicleModel}
              </Text>
            </View>
            <Text style={styles.transferAmountTextStyle}>
            {"\u20B9  "} { state?.value == "Tag To Pool" ? 
            (get(data,"accountBal", 0).toFixed(2))
            :( state?.target?.fastagBalance?.toString().includes(".") ? state?.target?.fastagBalance.toFixed(2) : state?.target?.fastagBalance + ".00")  }
            </Text>
            <View style={{marginLeft:20,width:20,height:20,borderRadius:10,backgroundColor:"green"}}>
                <View />
            </View>
          </View>
        </View>
        <View style={styles.secondContainer}>
          <Text style={[styles.selectedTextStyle,{marginBottom:10}]}>{"Enter Transfer Amount"}</Text>
          <CustomInput
                onValueChanged={(t) => setSelectedAmount(t)}
                value={selectedAmount}
                keyboardType="numeric"
                pattern={/^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/}
                errorMessage={"Enter Valid Amount"}
                maxLength={10}
                />
          {state?.vrn?.fastagBalance < selectedAmount ? <Text style={styles.exceedText}>Amount should not be exceeded with debit account</Text>:null}
          <View style={styles.quickAddViewStyle}>
            <Text style={styles.quickAddTextStyle}>{"Tap quick add"}</Text>
            <TouchableOpacity style={styles.quickRechargeViewStyle} onPress={() => setSelectedAmount("500")}>
              <Text style={styles.amountTextStyle}>{"500"}</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.quickRechargeViewStyle} onPress={() => setSelectedAmount("1000")}>
              <Text style={styles.amountTextStyle}>{"1000"}</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.quickRechargeViewStyle} onPress={() => setSelectedAmount("1500")}>
              <Text style={styles.amountTextStyle}>{"1500"}</Text>
            </TouchableOpacity>
          </View>
          <View style={styles.customButtonViewStyle}>
            <CustomButton disable={selectedAmount == "" || !rechargePattern.test(selectedAmount) || state?.vrn?.fastagBalance < selectedAmount ? true : false} text={"Transfer"} onPress={!selectedAmount ? null : state?.value == "Tag To Pool" ? () => onClickSubmit() : state?.value == "Tag To Tag" ? () => onsubmit() : null}/>
          </View>
        </View>
      </View>
      <View style={styles.quickLinksViewStyle}>
        <QuickLinks navigation={props.navigation} />
      </View>
      {otpModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <View style={styles.overlayContainer}>
            <View style={styles.overlay}>
              <View style={styles.overlayContentViewStyle}>
                <Text style={styles.enterOtpTextStyle}>{"Enter OTP"}</Text>
                <Text style={styles.otpDescTextStyle}>
                  {transferData.message}
                </Text>
                <TextInput
                  style={styles.otpInputViewStyle}
                  value={otp}
                  onChangeText={(t) => setOtp(t)}
                />
                 <View style={styles.resendViewStyle}>
                  <Countdown
                    ref={counterRef}
                    date={timerState.currentTime}
                    key={timerState.currentTimeIndex}
                    onComplete={completeTime}
                    intervalDelay={0}
                    precision={3}
                    renderer={timerRenderer}
                  />
                </View>
                <View
                  style={{
                    width: 123.5,
                    height: 36,
                    alignSelf: "center",
                    marginTop: 20,
                  }}
                >
                  <CustomButton
                    text={"Submit"}
                    onPress={() => {
                     validateOtp()
                    }}
                    disable={otp?.length === 6 ? false : true}
                  />
                </View>
              </View>
            </View>
          </View>
        </View>
      ) : null}
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
    </View>
  );
};


//make this component available to the app
export default PoolToTagTransferSummary;
